import './media.scss';
import * as React from 'react';
import { SectionTitle } from '../../components/layout/sectionTitle';
import { BackToTop } from '../../components/layout/shell/backToTop';
import Footer from '../../components/layout/shell/footer';
import { View } from '../../components/layout/view';
import { Pagination } from '../../components/navigation/pagination';
import { MediaCard } from '../../components/socialMedia/mediaCard';
import useMedia from '../../hooks/staticQueries/media/usePodcasts';
import { useNoHero } from '../../hooks/useHeaderFade';
import { RoutePaths } from '../../routes';
export const MediaPage = ({ pageContext }) => {
    const { group, index, pageCount } = pageContext;
    useNoHero();
    const { page } = useMedia();
    return (<View title="Media" className="podcasts" noHero>
      <SectionTitle title={page.top_copy.header} description={index === 1 && page.top_copy.description} imageTicket={page.top_copy.icon && page.top_copy.icon[0].ticket}/>

      <Pagination currentPage={index} totalPages={pageCount} newUrl={RoutePaths.media}/>

      <div className="media-cards-wrapper">
        {group && group.map((episode) => <MediaCard media={episode} key={episode.soundcloud_id + episode.vimeo_id + episode.title}/>)}
      </div>

      <Pagination currentPage={index} totalPages={pageCount} newUrl={RoutePaths.media}/>

      <Footer />

      <BackToTop />
    </View>);
};
export default MediaPage;
